export enum FulfillmentStepDisplayStatusType {
  NotScheduled = "NotScheduled",
  Unassigned = "Unassigned",
  Assigned = "Assigned",
  HeadingPickup = "HeadingPickup",
  ArrivedPickup = "ArrivedPickup",
  PickedUp = "PickedUp",
  HeadingDestination = "HeadingDestination",
  ArrivedDestination = "ArrivedDestination",
  Completed = "Completed",
  ContactNotAvailable = "ContactNotAvailable",
  Aborted = "Aborted  ",
  Canceled = "Canceled",
  OnHold = "OnHold"
}
